import SVTAPI from './svtapi';

class Delivery extends SVTAPI {
  /**
   * Initializes a new, existing delivery.
   *
   * @param {number} pid The pid of the delivery
   */
  constructor(pid) {
    super('/delivery');
    this._pid = pid;
  }

  /**
   * GET /delivery/:pid
   * Gets data of a single delivery.
   *
   * @returns {Object} The server's response
   */
  get() {
    return super.get({ url: '/' + this._pid });
  }

  /**
   * PATCH /delivery/:pid
   * Updates delivery data.
   *
   * @param   {Object} data The data to update
   * @returns {Object}      The server's response
   */
  patch(data) {
    return super.patch({ url: '/' + this._pid, data });
  }

  /**
   * DELETE /delivery/:pid
   * Deletes a delivery.
   *
   * @returns {Object}      The server's response
   */
  remove() {
    return super.remove({ url: '/' + this._pid });
  }
}

export default Delivery;
